import React, { useEffect, useState } from "react";
import BoeDetailView from "../components/BoeDetailView";
import "./SummaryRev.css";

const BoeDetailPage = () => {
  const [boeNo, setBoeNo] = useState(null);
  const [type, setType] = useState(null);
  const [displayType, setDisplayType] = useState(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Parse URL parameters
    const params = new URLSearchParams(window.location.search);
    const boeParam = params.get("boeNo");
    const typeParam = params.get("type");

    if (boeParam && typeParam) {
      setBoeNo(boeParam);
      setType(typeParam);
      setDisplayType(typeParam);
      setIsReady(true);
    } else {
      setIsReady(true);
    }
  }, []);

  const handleExportToExcel = () => {
    const tables = Array.from(document.querySelectorAll("table"));
    if (tables.length === 0) return;

    const toCsvRow = (arr) =>
      arr
        .map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`)
        .join(",");

    const csvContent = tables
      .map((table, idx) => {
        const sectionTitle =
          table.closest("div")?.querySelector("h3,h2,h4")?.textContent?.trim() ||
          `Table ${idx + 1}`;

        const rows = Array.from(table.querySelectorAll("tr")).map((row) => {
          const cells = Array.from(row.querySelectorAll("th,td")).map((cell) =>
            cell.textContent?.replace(/\s+/g, " ").trim() || ""
          );
          return toCsvRow(cells);
        });

        return [toCsvRow([sectionTitle]), ...rows].join("\n");
      })
      .join("\n\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `BOE_${boeNo}_${(displayType || type || "Details").replace(/\s+/g, "_")}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleClose = () => {
    window.close();
  };

  if (!isReady) {
    return (
      <div className="summary-loader-panel" style={{ minHeight: "100vh" }}>
        <div className="summary-spinner"></div>
      </div>
    );
  }

  if (!boeNo || !type) {
    return (
      <div className="detail-page">
        <div className="summary-empty-panel" style={{ margin: "auto", maxWidth: "420px" }}>
          <h1 style={{ fontSize: "18px", fontWeight: 700, marginBottom: "12px" }}>BoE Detail View</h1>
          <p style={{ color: "#a12d2d", marginBottom: "12px" }}>Invalid parameters. Please provide boeNo and type.</p>
          <button
            onClick={handleClose}
            className="summary-btn"
          >
            Close Window
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="detail-page">
      <div className="detail-header no-print">
        <div className="detail-header-title">
          Bill of Entry Details - ({boeNo})
          <span className="detail-header-type">Type: {displayType || type}</span>
        </div>
        <div className="detail-header-actions">
              <button
                onClick={handleExportToExcel}
                className="summary-icon-btn"
                title="Export to Excel"
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 16v-8m0 8l-3-3m3 3l3-3M4 20h16" />
                </svg>
              </button>
              <button
                onClick={handleClose}
                className="summary-icon-btn"
                title="Close"
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
        </div>
      </div>

      <div className="detail-body">
        <div className="detail-content">
          {boeNo && type && (
            <BoeDetailView
              boeNo={boeNo}
              type={type}
              onTypeChange={setDisplayType}
            />
          )}
        </div>
      </div>

      <div className="detail-footer no-print">
        <p>Generated on {new Date().toLocaleString()}</p>
      </div>

      <style>{`
        @media print {
          .no-print {
            display: none !important;
          }
          body {
            background: white;
            margin: 0;
            padding: 0;
          }
          @page {
            margin: 1cm;
          }
          .bg-gray-50 {
            background: white !important;
          }
          table {
            border-collapse: collapse;
          }
          td, th {
            border: 1px solid #ccc;
          }
          button {
            display: none !important;
          }
        }
      `}</style>
    </div>
  );
};

export default BoeDetailPage;
